import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

/**
 * 获取 Centrifugo 实时通知连接信息。
 */
export function getCentrifugoToken() {
    return request.get(config.baseApi + "/merchant/notification/centrifugo-token")
}
